import apiFetch from '@wordpress/api-fetch';

function savePublicationDownload() {
    const form = document.querySelector('.publication-form');
    if (form) {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            try {
                const data = await apiFetch({
                    url: '/wp-json/ebus-radar/v1/publications/download',
                    method: 'POST',
                    data: Object.fromEntries(new FormData(form).entries()),
                });

                if (data.download_url) {
                    const link = document.createElement('a');
                    link.href = data.download_url;
                    link.download = '';
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            } catch (error) {
                console.error(error);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    savePublicationDownload();
});
